import React from "react";

const Footer = () => {
  return (
    <div className="footer__container">
      <h1>Become A Pro'f &copy; {new Date().getFullYear()}</h1>
    </div>
  );
};

export default Footer;
